import router from "@/router";
import {
  getCurrentRole,
  getRefresh,
  getToken,
  saveToken,
} from "@/services/jwt.service";
import store from "@/store";
import axios from "axios";

let baseUrl = "/api/";
const $axios = axios.create({
  baseURL: baseUrl,
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

$axios.interceptors.request.use(
  (config) => {
    const token = getToken();
    const role = getCurrentRole();
    if (role) config.headers["Role"] = role;
    if (token) config.headers["Authorization"] = "Bearer " + token;
    if (
      config.url.includes("getotploginurl") ||
      config.url.includes("check-otp")
    )
      config.headers["Authorization"] = "";
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

$axios.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    const originalRequest = error.config;
    if (
      error.response?.status === 401 &&
      originalRequest.url === "refresh-token/"
    ) {
      isRefreshing = false;
      processQueue(error, null);
      store.commit("auth/PURGE_AUTH");
      if (router.currentRoute.path !== "/login") {
        router.push("/login");
      }
      return Promise.reject(
        "Your session has expired or is invalid. Please log in again.",
      );
    }

    if (error.response?.status === 401 && !originalRequest._retry) {
      const refreshToken = getRefresh();

      if (!refreshToken) {
        store.commit("auth/PURGE_AUTH");
        if (router.currentRoute.path !== "/login") {
          router.push("/login");
        }
        return Promise.reject(error);
      }

      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = "Bearer " + token;
            return $axios(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      return new Promise(function (resolve, reject) {
        $axios
          .post("refresh-token/", {
            refresh: refreshToken,
          })
          .then((res) => {
            if (res.status === 200) {
              saveToken(res.data.access);
              $axios.defaults.headers.common["Authorization"] =
                "Bearer " + getToken();
              originalRequest.headers["Authorization"] =
                "Bearer " + res.data.access;
              originalRequest.url = originalRequest.url.replaceAll("api/", "");
              processQueue(null, res.data.access);
              resolve($axios(originalRequest));
            }
          })
          .catch((err) => {
            processQueue(err, null);
            reject(err);
          })
          .finally(() => {
            isRefreshing = false;
          });
      });
    }
    return Promise.reject(error);
  },
);

export default $axios;
